module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/CREW_BOOK_NATIONAL_france.b93438a7.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/CREW_BOOK_NATIONAL_france.png
// module id = 1189
// module chunks = 16